export default __webpack_public_path__ + "static/media/telco_green.d6c89f73.svg";